import { render } from "./AbbreviationsList.vue?vue&type=template&id=1392b224"
import script from "./AbbreviationsList.vue?vue&type=script&lang=js"
export * from "./AbbreviationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__